import { useEffect, useState } from 'react'
import { getPdHackCategories } from '@domain/features/pd-hacks/pd-hacks-feature'
import type { PdHackCategory } from '@domain/models/pd-hacks'

export function usePdHackCategories(activeOnly = true, enabled = true) {
  const [categories, setCategories] = useState<PdHackCategory[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!enabled) {
      setLoading(false)
      return
    }

    let cancelled = false

    setLoading(true)
    setError(null)
    setCategories([])

    async function load() {
      try {
        const result = await getPdHackCategories(activeOnly)
        if (!cancelled) {
          setCategories(result)
        }
      } catch (caughtError) {
        if (!cancelled) {
          setCategories([])
          setError(
            caughtError instanceof Error
              ? caughtError.message
              : 'Failed to load PD hacks categories.',
          )
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    void load()
    return () => {
      cancelled = true
    }
  }, [activeOnly, enabled])

  return {
    categories,
    loading,
    error,
    hasCategories: categories.length > 0,
  }
}
